export default __webpack_public_path__ + "static/media/Composant 28 – 61.e4b62a68.svg";